export const DEFAULT_SOURCE_FORMAT = {
  width: 1280,
  height: 720,
  fps: 30,
};

export const COMMON_SOURCE_FORMATS = [
  { width: 3840, height: 2160, fps: 60 },
  { width: 3840, height: 2160, fps: 30 },
  { width: 2560, height: 1440, fps: 60 },
  { width: 2560, height: 1440, fps: 30 },
  { width: 1920, height: 1080, fps: 60 },
  { width: 1920, height: 1080, fps: 30 },
  { width: 1600, height: 900, fps: 60 },
  { width: 1600, height: 900, fps: 30 },
  { width: 1280, height: 720, fps: 60 },
  { width: 1280, height: 720, fps: 30 },
  { width: 960, height: 540, fps: 60 },
  { width: 960, height: 540, fps: 30 },
  { width: 854, height: 480, fps: 60 },
  { width: 854, height: 480, fps: 30 },
  { width: 640, height: 480, fps: 60 },
  { width: 640, height: 480, fps: 30 },
  { width: 640, height: 360, fps: 60 },
  { width: 640, height: 360, fps: 30 },
  { width: 640, height: 360, fps: 24 },
];

export const COMMON_RENDER_SIZES = [
  { width: 3840, height: 2160 },
  { width: 2560, height: 1440 },
  { width: 1920, height: 1080 },
  { width: 1600, height: 900 },
  { width: 1280, height: 720 },
  { width: 960, height: 540 },
  { width: 854, height: 480 },
  { width: 640, height: 480 },
  { width: 640, height: 360 },
];

export function toPositiveNumber(value, fallback = 0) {
  return Number.isFinite(value) && value > 0 ? Number(value) : fallback;
}

export function formatFpsValue(value) {
  const fps = toPositiveNumber(value, 0);
  if (!fps) {
    return "?";
  }

  return Number.isInteger(fps) ? String(fps) : fps.toFixed(1);
}

export function makeSourceFormatKey(width, height, fps) {
  return `${Math.round(width)}x${Math.round(height)}@${Math.round(fps)}`;
}

export function makeRenderTargetKey(width, height) {
  return `${Math.round(width)}x${Math.round(height)}`;
}

export function formatSourceLabel(width, height, fps) {
  return `${width}x${height} @ ${formatFpsValue(fps)}fps`;
}

export function formatRenderLabel(width, height, fps) {
  return `${width}x${height} @ ${formatFpsValue(fps)}fps`;
}

export function normalizeDeviceLabel(value) {
  return String(value || "").trim().toLowerCase();
}
